import {
  ODataHeader,
  ODataString,
  ODataDate,
  ODataBoolean,
  ODataInteger
} from "pbas-vue-components";
import { translate2 } from "../trans2";

const CoverageHeaders = [
  new ODataHeader({
    type: new ODataBoolean("IncludePPT"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeHST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeGST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludePST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeRST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IsTaxableBenefit"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("Identity/IsReadOnly"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("HasVolume"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("HasAdminFees"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("HasOperatingFees"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    title: "Id",
    type: new ODataString("IdentityId"),
    sortable: true,
    visible: false,
    searchable: false,
    isIdentifier: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataBoolean("Identity/HasHistory"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataString("Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Name"),
    sortable: true,
    visible: false,
    allowVisibilityChange: false,
    searchable: true,
    version: 1,
  }), 
  new ODataHeader({
    type: new ODataString("PlanInsuranceCarrierId"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString(
      "PlanInsuranceCarrier/InsuranceCarrier/Translations[]/LanguageCode"
    ),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString(
      "PlanInsuranceCarrier/InsuranceCarrier/Translations[]/Id"
    ),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("PlanInsuranceCarrier/Id"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("PlanInsuranceCarrier/PolicyIdentity/Current/Number"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("PlanInsuranceCarrier/InsuranceCarrier/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    allowVisibilityChange: false,
    version: 1,
  }),
  new ODataHeader({
    type: new ODataString("TrustFund/Translations[]/LanguageCode"),
    sortable: false,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    type: new ODataString("TrustFund/Name"),
    sortable: true,
    visible: false,
    searchable: true,
    version: 2,
    allowVisibilityChange: false,
  }),
  new ODataHeader({
    title: "components.getreports.trust_fund",
    type: new ODataString("TrustFund/Id"),
    sortable: true,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "components.getreports.trust_fund",
    type: new ODataString("TrustFundId"),
    sortable: true,
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
  }),
  new ODataHeader({
    title: "globals.name",
    type: new ODataString("Translations[]/Name", {
      getString: (item) => translate2(item, "Name"),
      additionalKeys: [new ODataString("Name")],
    }),
    sortable: true,
    visible: true,
    allowVisibilityChange: true,
    searchable: true,
    version: 1,
    orderByKey: "Name",
  }),
  new ODataHeader({
    title: "globals.description",
    type: new ODataString("Translations[]/Description", {
      getString: (item) => translate2(item, "Description"),
      getHtml: (item, type) => {
        return (
          "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
          type.getString(item, type) +
          "</div>"
        );
      },
      additionalKeys: [new ODataString("Description")],
    }),
    sortable: true,
    visible: true,
    searchable: true,
    version: 1,
    orderByKey: "Description",
  }),
  new ODataHeader({
    title: "globals.order",
    type: new ODataInteger("Order"),
    visible: true,
    sortable: true,
    searchable: true,
    orderByKey: "Order"
  }),    
  new ODataHeader({
    title: "components.inmemorydependants.effective_date",
    type: new ODataDate("EffectiveDate"),
    sortable: true,
    visible: true,
    searchable: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeAdminPPT"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeAdminRST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeAdminHST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeAdminGST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeAdminPST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeOperatingPPT"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeOperatingRST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeOperatingHST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeOperatingGST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeOperatingPST"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("MinVolume"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("MaxVolume"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("VolumeBasedOnAge"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimAdminFee"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimPPTAdminTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimRSTAdminTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimHSTAdminTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimPSTAdminTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimGSTAdminTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimQSTAdminTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommission"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommissionPPTTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommissionRSTTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommissionHSTTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommissionPSTTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommissionGSTTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeClaimCommissionQSTTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatCommission"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatPPTCommissionTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatRSTCommissionTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatHSTCommissionTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatPSTCommissionTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatGSTCommissionTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
  new ODataHeader({
    type: new ODataBoolean("IncludeFlatQSTCommissionTax"),
    visible: false,
    allowVisibilityChange: false,
    searchable: false,
    alwaysInclude: true,
  }),
];
export default CoverageHeaders;
